import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'

import { IForm } from 'core-components/classes/models/IForm'
import { Grid, Item } from 'core-components/library/grid'

import styles from '../ContactTileCell.module.scss'

import RenderCardHead from './RenderCardHead'
import { renderCardStatusLine } from './tileBlocksMethods'

export default function addressBlock(item: DataModel | IForm) {
  return (
    <Grid className={styles.dataGrid} wrap={'nowrap'}>
      <Item xs={'auto'}>{renderCardStatusLine(item)}</Item>
      <Item xs={'auto'}>
        <span className={classNames(styles.dataIcon, 'kbase kbase-omni-location-pin')} />
      </Item>
      <Item xs={true}>
        <p className={styles.data}>
          <span className={styles.data__label}>Company:</span>
          <span className={styles.data__value}>{item.get('CommunicationName')}</span>
        </p>
        {(item.get('AddressLine1') || '').length ? (
          <p className={styles.data}>
            <span className={styles.data__label}>Address 1:</span>
            <span className={styles.data__value}>{item.get('AddressLine1')}</span>
          </p>
        ) : null}
        {(item.get('AddressLine2') || '').length ? (
          <p className={styles.data}>
            <span className={styles.data__label}>Address 2:</span>
            <span className={styles.data__value}>{item.get('AddressLine2')}</span>
          </p>
        ) : null}
        {(item.get('AddressLine3') || '').length ? (
          <p className={styles.data}>
            <span className={styles.data__label}>Address 3:</span>
            <span className={styles.data__value}>{item.get('AddressLine3')}</span>
          </p>
        ) : null}
        <p className={styles.data}>
          <span className={styles.data__label}>City:</span>
          <span className={styles.data__value}>{item.get('City')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>Postal Code:</span>
          <span className={styles.data__value}>{item.get('ZIPCode')}</span>
        </p>
        <p className={styles.data}>
          <span className={styles.data__label}>Country:</span>
          <span className={styles.data__value}>{item.get('Country')}</span>
        </p>
      </Item>
      <Item xs={'auto'}>
        <RenderCardHead item={item} />
      </Item>
    </Grid>
  )
}
